// src/services/accountService.js
import http from "../api/http";

/** Map DB -> UI */
function mapProfileFromDb(db) {
  if (!db) return null;
  return {
    id: db.IDTiers ?? db.id ?? null,
    codtiers: db.CodTiers ?? db.codTiers ?? "",
    name: db.Raisoc || db.name || "",
    email: db.Email || db.email || "",
    phone: db.Tel || db.Gsm || db.phone || "",
    address: db.Adresse || db.address || "",
    avatarUrl: null,
    raw: db,
  };
}

/** Map UI -> DB (pour update) */
function mapProfileToDb(form) {
  return {
   address: form.address ?? "",
    phone: form.phone ?? "",
    email: form.email ?? "",
  };
}

export const accountService = {
  /** Récupère le profil via /api/users/:codtiers */
  getProfile: async (codtiers) => {
    const { data } = await http.get(`/api/users/${encodeURIComponent(codtiers)}`);
    return mapProfileFromDb(data);
  },

  /**
   * ✅ Met à jour le profil côté BD via PUT /api/profile/me
   * - Le backend résout CodTiers via auth ou via header x-codtiers.
   * - Le controller exige address + phone obligatoires.
   */
  updateProfile: async (codtiers, payload) => {
    const body = mapProfileToDb(payload);

    const { data } = await http.put("/api/profile/me", body, {
      headers: {
        "x-codtiers": String(codtiers || "").trim(),
      },
    });

    // data attendu: { codTiers, address, phone }
    // On renvoie un profil UI cohérent pour que le front puisse refresh proprement
    return {
      codtiers: data?.codTiers ?? codtiers,
      phone: data?.phone ?? body.phone,
      address: data?.address ?? body.address,
      success: true,
      raw: data,
    };
  },
};
